import { InputChipProps } from '@cast/design-system';

export const FREE_TEXT_CHIP_KEY = 'free-text-chip';

export const baseChipProps: Partial<InputChipProps> = {
  delimiter: '',
  size: 'md',
  sx: { backgroundColor: 'indigo.300', color: '#fff' },
  titleProps: { variant: 'P12M' },
  valueProps: { variant: 'P12R' },
};
